

import { useEffect } from 'react';
import editModeManager from '../utils/EditModeManager';








/**
 * Custom hook to handle edit mode coordination across components
 * Ensures only one component can be in edit mode at a time
 *
 * @param {UseEditModeManagerOptions} options - Configuration options
 * @param {string} options.componentId - Unique identifier for the component
 * @param {Function} options.callbackToHide - Function to call when component should exit edit mode
 * @param {boolean} [options.optionalConditionToHide] - Optional condition that must be true to trigger hide callback
 * @param {Array<mixed>} [options.dependencies] - Additional dependencies for the useEffect hook
 * @return {void}
 */
const useEditModeManager = ({
  componentId,
  callbackToHide,
  optionalConditionToHide = true,
  dependencies = []
}) => {
  useEffect(() => {
    const handleEditModeChange = (activeId) => {
      if (activeId !== componentId && optionalConditionToHide) {
        callbackToHide();
      }
    };

    editModeManager.addEventListener(handleEditModeChange);

    return () => {
      editModeManager.removeEventListener(handleEditModeChange);
    };
  }, [componentId, optionalConditionToHide, callbackToHide, ...dependencies]);
};

export default useEditModeManager;